const STORAGE_KEY = 'vortex_text_size';

const SIZES = {
  small: { label: 'Chico', rootFontSize: '14px' },
  medium: { label: 'Mediano', rootFontSize: '16px' },
  large: { label: 'Grande', rootFontSize: '20px' },
};

export const getTextSizes = () => SIZES;

export const getTextSize = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'medium';
  } catch {
    return 'medium';
  }
};

export const setTextSize = (size) => {
  try {
    localStorage.setItem(STORAGE_KEY, size);
  } catch {}
  applyTextSize(size);
};

export const applyTextSize = (size) => {
  const config = SIZES[size] || SIZES.medium;
  document.documentElement.style.fontSize = config.rootFontSize;
};
